import { Component, OnDestroy, output } from '@angular/core';
import { IAddressHistory, ICOBHistory, ICoverageHistory, IEligHistory, IPersonHistory, ISummaryOfChangesState, ITransactions } from '../../store/summaryOfChanges/state';
import { getAddressHistoryResponse, getCobSearchResponse, getCoverageResponse, getMemberEligResponse, getPersonHistoryResponse, getSelectedTransaction } from '../../store/summaryOfChanges/selector';
import { initialStateSummaryOfChange } from '../../store/summaryOfChanges/initialState';
import { Lux } from '@roosevelt/common-ui-lib/core';
import { toSignal } from '@angular/core/rxjs-interop';

@Component({
    selector: 'app-summary-details',
    template: `
      <app-summary-details-page
        [transaction]="selectedTransaction() ?? defaultTransaction"
        [memberEligHistory]="memberEligHistory()"
        [cobHistory]="cobHistory()"
        [coverageHistory]="coverageHistory()"
        [personHistory]="personHistory()"
        [addressHistory]="addressHistory()"
        (backSearch)="backSearch()"></app-summary-details-page>
    `,
    standalone: false
})
export class SummaryDetailsContainer implements OnDestroy {
  readonly luxId = 'BMT-SummaryDetails-Comp' + this.constructor.name;
  readonly backToTransactions = output<boolean>();
  readonly defaultTransaction = {} as ITransactions;
  readonly selectedTransaction = toSignal(this.lux.get(getSelectedTransaction, this.luxId), { initialValue: undefined as ITransactions | undefined });
  readonly memberEligHistory = toSignal(this.lux.get(getMemberEligResponse, this.luxId), { initialValue: [] as IEligHistory[] });
  readonly cobHistory = toSignal(this.lux.get(getCobSearchResponse, this.luxId), { initialValue: [] as ICOBHistory[] });
  readonly coverageHistory = toSignal(this.lux.get(getCoverageResponse, this.luxId), { initialValue: [] as ICoverageHistory[] });
  readonly personHistory = toSignal(this.lux.get(getPersonHistoryResponse, this.luxId), { initialValue: [] as IPersonHistory[] });
  readonly addressHistory = toSignal(this.lux.get(getAddressHistoryResponse, this.luxId), { initialValue: [] as IAddressHistory[] });

  constructor(private readonly lux: Lux<{ sChanges: ISummaryOfChangesState }>) {
  }

  backSearch(): void {
    this.backToTransactions.emit(true);
    this.lux.set(state => state.sChanges, {
      selectedTransaction: initialStateSummaryOfChange.selectedTransaction,
      memberEligHistoryRes: initialStateSummaryOfChange.memberEligHistoryRes,
      cobHistoryRes: initialStateSummaryOfChange.cobHistoryRes,
      coverageHistoryRes: initialStateSummaryOfChange.coverageHistoryRes,
      personHistoryRes: initialStateSummaryOfChange.personHistoryRes,
      addressHistoryRes: initialStateSummaryOfChange.addressHistoryRes
    });
  }

  ngOnDestroy(): void {
    this.lux.destroy(this.luxId);
  }
}
